/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M17.8359 6.7318c.0001 0-.0002 0 0 0-.4041-.091-.6585-.4923-.5676-.8964a.7504.7504 0 0 1 .6866-.5842.7507.7507 0 0 1 .2098.017l2.2999.5176a10.5617 10.5617 0 0 0-2.1536-2.1785c-1.5903-1.1978-3.5312-1.9535-5.6411-2.0863A10.6653 10.6653 0 0 0 12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12a.75.75 0 0 1 1.5 0c0 6.6274-5.3726 12-12 12S0 18.6274 0 12 5.3726 0 12 0c.2601 0 .5182.0083.7742.0246C15.109.1733 17.2626.99 19.0453 2.285a12.067 12.067 0 0 1 2.8628 2.9433l.6107-2.7144c0 .0002 0 0 0 0a.75.75 0 1 1 1.4635.329l-1.129 5.0178-5.0174-1.1289Z"
    clipRule="evenodd"
  />,
  'Refresh'
);
